import React from 'react';
import { defaults, Pie } from 'react-chartjs-2';
import { IPieChart } from './interface';

defaults.global.maintainAspectRatio = false;

function PieChart(props: IPieChart) {
  const data = {
    datasets: [
      {
        data: props.data,
        backgroundColor: props.backgroundColors,
        hoverBackgroundColor: props.hoverBackgroundColors,
      },
    ],

    labels: props.labels,
  };

  return (
    <Pie
      data={data}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
        },
      }}
    />
  );
}

export default PieChart;
